import { getLocalStorage } from '../browserStorageHandler';
import { IS_TELCO_USER } from '../constants/localStorageConstants';

export const isTelcoUser = () => {
  const isTelcoUserString = getLocalStorage(IS_TELCO_USER);
  if (isTelcoUserString && isTelcoUserString === 'true') {
    return true;
  }
  return false;
};
